// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"4e1739cf","292":"4e1739cf","537":"634d01da"}[chunkId] + ".chunk.css";
};